/**
 * Export all constructs under the models namespace.
 */

export * from "@courses-models/progression/src/ts/config/api";
